import React, { useState } from "react";
import Notiflix from "notiflix";

import {
  Row,
  Form,
  Col,
  Divider,
  Spin,
  Table,
  Typography,
  Select,
  Button,
  Modal,
  Tooltip,
} from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { BOM } from "../../../../../services/definedMethod";
import styles from "../../../../../assets/styles/styles";

const MapFees = (props) => {
  //DECLARED VARIABLES
  const {
    onFinish,
    form,
    userData,
    isLoading,
    setIsLoading,
    mapFeeTableSource,
    setMapFeeTableSource,
    charges,
    incomeAccountOptions,
    chargesOptions,
    feeCount,
    setFeeCount,
  } = props;
  const { session } = userData;
  const { Title } = Typography;

  // DECLARED VARIABLES FOR FORM
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleMapFeeDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.incomeAccountValue, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = mapFeeTableSource.filter((item) => item.id !== key.id);
        setMapFeeTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: "Fees",
      dataIndex: "chargeValue",
    },
    {
      title: "Income Account",
      dataIndex: "incomeAccountValue",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        mapFeeTableSource.length >= 1 ? (
          <Tooltip title={`Remove`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleMapFeeDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Map Fees to Income Accounts
        </Title>
      </Divider>
      <MapFeesModal
        isModalOpen={isModalOpen}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setIsModalOpen={setIsModalOpen}
        charges={charges}
        incomeAccountOptions={incomeAccountOptions}
        setMapFeeTableSource={setMapFeeTableSource}
        mapFeeTableSource={mapFeeTableSource}
        session={session}
        feeCount={feeCount}
        setFeeCount={setFeeCount}
        chargesOptions={chargesOptions}
      />

      {mapFeeTableSource?.length > 0 && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {mapFeeTableSource.length > 1
                ? "Selected Income Accounts"
                : "Selected Income Account"}
            </Title>
          </Divider>

          <Col span={24}>
          <Table
            columns={columns}
            dataSource={mapFeeTableSource}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: "10",
            }}
          />
          </Col>
        </>
      )}
    </>
  );
};
export default MapFees;

const MapFeesModal = (props) => {
  const {
    session,
    isLoading,
    setIsLoading,
    setMapFeeTableSource,
    mapFeeTableSource,
    isModalOpen,
    setIsModalOpen,
    charges,
    incomeAccountOptions,
    chargesOptions,
    feeCount,
    setFeeCount,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleMapFeeSave = (formValues) => {
    const newCharges = {
      key: feeCount,
      id: feeCount,
      incomeAccountId: formValues.incomeAccountId,
      chargeId: formValues.chargeId,
      chargeValue: charges.find((item) => item.value === formValues.chargeId)
        .label,
      incomeAccountValue: incomeAccountOptions.find(
        (item) => item.value === formValues.incomeAccountId
      ).label,
    };

    setFeeCount(feeCount + 1);
    setMapFeeTableSource([...mapFeeTableSource, newCharges]);

    useForm.resetFields();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#15CCAE",
          marginBottom: 20,
        }}
        shape="round"
      >
        {"Add Income Account"}
      </Button>

      <Modal
        title="Income Account Information Setup"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleMapFeeSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider />

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"chargeId"}
                label={"Fees"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Fees"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg("Fees", "select")}
                  options={chargesOptions}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                name={"incomeAccountId"}
                label={"Income Account"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld("Income Account"),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    "Income Account",
                    "select"
                  )}
                  options={incomeAccountOptions}
                  //   onChange={handleSelectedCharge}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </Row>
  );
};
